import applyStyles from "../utils/applyStyles.js";
import { evaluateScript } from "../utils/evaluateScriptOnDom.js";

export class ComponentError extends Error {}

export const PARSER = new DOMParser();

export function handleResponse(response) {
    evaluateScript(response.component_javascript);
    /**
     * @TODO ensure that component styles are properly scoped, layered and unique
     */
    applyStyles(response.css);
}

export function findComponent(document, componentId) {
    const element = document.querySelector(`.rm-component[data-node-id="${componentId}"]`);
    if (element) {
        return element;
    }
    throw new ComponentError(`Component ${componentId} not found`);
}
